/*
 * "Pair It Perfectly With" — cart drawer cross-sell behaviour (Lily).
 *
 * The carousel markup is injected into the cart drawer via innerHTML on every
 * cart change, so inline scripts never run. Everything here is therefore:
 *   - delegated from `document` (survives re-renders), and
 *   - idempotent (safe to load once, runs for the life of the page).
 *
 * Add-to-cart uses the theme's own refresh events (theme:cart:change +
 * theme:cart:reload) so the drawer, header count and totals all update.
 */
(function () {
  'use strict';
  if (window.__lilyPairInit) return;
  window.__lilyPairInit = true;

  var SEL = {
    pair: '[data-lily-pair]',
    track: '[data-lily-pair-track]',
    add: '[data-lily-pair-add]',
    prev: '[data-lily-pair-prev]',
    next: '[data-lily-pair-next]',
    data: 'script[data-lily-pair-product]'
  };

  function cartRoute() {
    return (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
  }

  /* ---------------------------------------------------------------- refresh */
  function refreshCart() {
    return fetch(cartRoute() + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      });
  }

  function addToCart(variantId) {
    return fetch(cartRoute() + '/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw j; });
      return r.json();
    });
  }

  /* ------------------------------------------------------------ size popup */
  var modal = null;
  var modalState = { variantId: null };

  function buildModalShell() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'lily-pairm';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<div class="lily-pairm__overlay" data-pairm-close></div>' +
      '<div class="lily-pairm__dialog">' +
      '  <button type="button" class="lily-pairm__close" data-pairm-close aria-label="Затвори">' +
      '    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 2L14 14M14 2L2 14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
      '  </button>' +
      '  <div class="lily-pairm__body">' +
      '    <div class="lily-pairm__head">' +
      '      <div class="lily-pairm__img"><img data-pairm-img src="" alt=""></div>' +
      '      <div class="lily-pairm__meta">' +
      '        <h3 class="lily-pairm__title" data-pairm-title></h3>' +
      '        <div class="lily-pairm__price" data-pairm-price></div>' +
      '      </div>' +
      '    </div>' +
      '    <div class="lily-pairm__sizelabel">Големина:<strong data-pairm-sizeval></strong></div>' +
      '    <div class="lily-pairm__sizes" data-pairm-sizes></div>' +
      '    <button type="button" class="lily-pairm__cta" data-pairm-add disabled>Додај во кошничка</button>' +
      '  </div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.querySelectorAll('[data-pairm-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
    modal.querySelector('[data-pairm-add]').addEventListener('click', function () {
      var btn = this;
      if (!modalState.variantId) return;
      btn.disabled = true;
      addToCart(modalState.variantId)
        .then(function () { btn.textContent = 'Додадено ✓'; return refreshCart(); })
        .then(function () { setTimeout(closeModal, 700); })
        .catch(function () { btn.textContent = 'Обиди се повторно'; btn.disabled = false; });
    });
    return modal;
  }

  function openModal() { buildModalShell().classList.add('is-open'); }
  function closeModal() { if (modal) modal.classList.remove('is-open'); }

  function findVariant(d, sz) {
    var key = 'o' + (d.size_index + 1);
    for (var i = 0; i < d.variants.length; i++) {
      if (d.variants[i][key] === sz) return d.variants[i];
    }
    return null;
  }

  function selectSize(btn, id, sz) {
    var sizes = modal.querySelector('[data-pairm-sizes]');
    sizes.querySelectorAll('.lily-pairm__size').forEach(function (b) { b.classList.remove('is-selected'); });
    btn.classList.add('is-selected');
    modalState.variantId = id;
    modal.querySelector('[data-pairm-sizeval]').textContent = sz;
    var add = modal.querySelector('[data-pairm-add]');
    add.disabled = false;
    add.textContent = 'Додај во кошничка';
  }

  function buildModal(d) {
    buildModalShell();
    var img = modal.querySelector('[data-pairm-img]');
    img.src = d.image; img.alt = d.title;
    modal.querySelector('[data-pairm-title]').textContent = d.title;

    var price = modal.querySelector('[data-pairm-price]');
    if (d.on_sale) {
      price.innerHTML = '<span class="lily-pairm__price-sale"></span> <s class="lily-pairm__price-was"></s>';
      price.querySelector('.lily-pairm__price-sale').textContent = d.price_formatted;
      price.querySelector('.lily-pairm__price-was').textContent = d.compare_formatted;
    } else {
      price.innerHTML = '<span></span>';
      price.querySelector('span').textContent = d.price_formatted;
    }

    var sizes = modal.querySelector('[data-pairm-sizes]');
    sizes.innerHTML = '';
    modal.querySelector('[data-pairm-sizeval]').textContent = '';
    modalState.variantId = null;
    modal.querySelector('[data-pairm-add]').disabled = true;

    var firstAvail = null;
    d.sizes.forEach(function (sz) {
      var v = findVariant(d, sz);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lily-pairm__size';
      btn.textContent = sz;
      if (!v || !v.available) {
        btn.classList.add('lily-pairm__size--soldout');
        btn.disabled = true;
      } else {
        btn.addEventListener('click', function () { selectSize(btn, v.id, sz); });
        if (!firstAvail) firstAvail = { btn: btn, id: v.id, sz: sz };
      }
      sizes.appendChild(btn);
    });
    if (firstAvail) selectSize(firstAvail.btn, firstAvail.id, firstAvail.sz);
  }

  /* ------------------------------------------------------------ add button */
  function directAdd(btn) {
    var label = btn.querySelector('.lily-pair__add-label') || btn;
    var original = label.textContent;
    btn.disabled = true;
    addToCart(btn.getAttribute('data-variant-id'))
      .then(function () {
        btn.classList.add('is-added');
        label.textContent = 'Додадено ✓';
        return refreshCart();
      })
      .then(function () {
        // The card is replaced on re-render; restore is only a fallback.
        setTimeout(function () {
          btn.classList.remove('is-added');
          label.textContent = original;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function () { label.textContent = original; btn.disabled = false; });
  }

  function onAddClick(btn) {
    if (btn.getAttribute('data-multi') === 'true') {
      var id = btn.getAttribute('data-product-id');
      var card = btn.closest('.lily-pair__card');
      var tag = card && card.querySelector('script[data-lily-pair-product="' + id + '"]');
      if (!tag) { window.location.href = btn.getAttribute('data-product-url'); return; }
      try { buildModal(JSON.parse(tag.textContent)); openModal(); }
      catch (e) { window.location.href = btn.getAttribute('data-product-url'); }
    } else {
      directAdd(btn);
    }
  }

  /* --------------------------------------------------------------- arrows */
  function trackOf(el) {
    var pair = el.closest(SEL.pair);
    return pair ? pair.querySelector(SEL.track) : null;
  }

  function scrollByCard(track, dir) {
    var card = track.querySelector('.lily-pair__card');
    var step = card ? card.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  function updateArrows(pair) {
    var track = pair.querySelector(SEL.track);
    var prev = pair.querySelector(SEL.prev);
    var next = pair.querySelector(SEL.next);
    if (!track || !prev || !next) return;
    var scrollable = track.scrollWidth - track.clientWidth > 4;
    prev.hidden = !scrollable;
    next.hidden = !scrollable;
    if (!scrollable) return;
    prev.disabled = track.scrollLeft <= 1;
    next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
  }

  function initPairs(root) {
    (root || document).querySelectorAll(SEL.pair).forEach(function (pair) {
      updateArrows(pair);
      var track = pair.querySelector(SEL.track);
      if (track && !track.dataset.lilyBound) {
        track.dataset.lilyBound = '1';
        track.addEventListener('scroll', function () { updateArrows(pair); }, { passive: true });
      }
    });
  }

  /* ------------------------------------------------ recommendations (API) */
  var RECO_SECTION = 'api-pair-recommendations';

  function recommendRoute() {
    return (window.theme && window.theme.routes && window.theme.routes.product_recommendations_url) || '/recommendations/products';
  }

  // Fetch one cart product's recommendations and return its rendered cards.
  function fetchRecoCards(productId, intent, limit) {
    var url = recommendRoute() +
      '?section_id=' + RECO_SECTION +
      '&product_id=' + encodeURIComponent(productId) +
      '&limit=' + encodeURIComponent(limit) +
      '&intent=' + encodeURIComponent(intent);
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        return Array.prototype.slice.call(tmp.querySelectorAll('.lily-pair__card'));
      })
      .catch(function () { return []; });
  }

  function cardProductId(card) {
    var el = card.querySelector('[data-product-id]');
    return el ? el.getAttribute('data-product-id') : null;
  }

  // Fetch one intent for every cart product, then merge + de-dupe across them
  // (excluding products already in the cart). Returns [] if nothing came back.
  function fetchIntent(ids, intent, limit, excluded) {
    return Promise.all(ids.map(function (id) { return fetchRecoCards(id, intent, limit); }))
      .then(function (groups) {
        var seen = {}, out = [];
        groups.forEach(function (cards) {
          cards.forEach(function (card) {
            var pid = cardProductId(card);
            if (!pid || excluded[pid] || seen[pid]) return;
            seen[pid] = true;
            out.push(card);
          });
        });
        return out;
      });
  }

  function hydrateOne(pair) {
    if (pair.dataset.lilyRecoDone) return;       // once per render; guards re-entry
    pair.dataset.lilyRecoDone = '1';

    var ids = (pair.getAttribute('data-lily-pair-cart-ids') || '').split(',').filter(Boolean);
    var intent = pair.getAttribute('data-lily-pair-intent') || 'auto';
    var limit = parseInt(pair.getAttribute('data-lily-pair-limit'), 10) || 8;
    var track = pair.querySelector(SEL.track);
    if (!ids.length || !track) return;

    // A pinned "featured" product (settings.cart_pair_with_featured) stays first
    // and must survive the track being replaced by recommendations.
    var featuredCard = track.querySelector('[data-lily-pair-featured]');
    var featuredId = featuredCard ? cardProductId(featuredCard) : null;

    var excluded = {};
    ids.forEach(function (id) { excluded[id] = true; });
    if (featuredId) excluded[featuredId] = true;

    // 'auto' tries complementary first, then related if that came back empty.
    var rounds = intent === 'complementary' ? ['complementary']
               : intent === 'related' ? ['related']
               : ['complementary', 'related'];

    function run(i) {
      if (i >= rounds.length) return Promise.resolve([]);
      return fetchIntent(ids, rounds[i], limit, excluded).then(function (cards) {
        return cards.length ? cards : run(i + 1);
      });
    }

    run(0).then(function (cards) {
      if (cards.length) {
        // Recommendations win — replace the server-rendered collection baseline,
        // but keep the pinned featured product first if present.
        track.innerHTML = '';
        if (featuredCard) track.appendChild(featuredCard);
        var room = featuredCard ? limit - 1 : limit;
        cards.slice(0, room).forEach(function (c) { track.appendChild(c); });
      }
      // No recommendations and no baseline cards -> nothing to show.
      if (!track.querySelector('.lily-pair__card')) {
        pair.style.display = 'none';
      }
      updateArrows(pair);
    });
  }

  function hydrateRecommendations(root) {
    (root || document).querySelectorAll('[data-lily-pair-recommend]').forEach(hydrateOne);
  }

  /* ------------------------------------------------------------ delegation */
  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest(SEL.add);
    if (add) { e.preventDefault(); onAddClick(add); return; }
    var prev = e.target.closest && e.target.closest(SEL.prev);
    if (prev) { var tp = trackOf(prev); if (tp) scrollByCard(tp, -1); return; }
    var next = e.target.closest && e.target.closest(SEL.next);
    if (next) { var tn = trackOf(next); if (tn) scrollByCard(tn, 1); return; }
  });

  // Keep arrow state correct as the drawer re-renders the line-items region.
  function watch(container) {
    if (!container) return;
    new MutationObserver(function () {
      initPairs(container);
      hydrateRecommendations(container);
    }).observe(container, { childList: true, subtree: true });
  }

  function boot() {
    initPairs(document);
    hydrateRecommendations(document);
    watch(document.querySelector('[data-line-items]'));
    watch(document.querySelector('[data-section-type="cart"]'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('resize', function () { initPairs(document); });
})();
